import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHashtag12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconHashtag12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Hashtag12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.424 1.07a.5.5 0 0 0-.99-.14L4.066 3.5H1.714a.5.5 0 1 0 0 1h2.21l-.43 3H1a.5.5 0 0 0 0 1h2.352l-.347 2.43a.5.5 0 0 0 .99.14l.367-2.57h2.561l-.347 2.43a.5.5 0 0 0 .99.14l.368-2.57h2.352a.5.5 0 1 0 0-1h-2.21l.429-3H11a.5.5 0 0 0 0-1H8.648l.347-2.43a.5.5 0 0 0-.99-.14L7.638 3.5H5.077zm-.49 3.43-.429 3h2.561l.429-3z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Hashtag12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconHashtag12);
